    //Slider Control
jQuery(document).ready(function(){
    
//smooth scrolling

    $('.btn-go-top').on('click',function (e) {
        e.preventDefault();
        var target =  $('#top'),
            $target = $(target);
        $('html, body').stop().animate({
            'scrollTop': $target.offset().top
        }, 700, 'swing', function () {
             
        });
    });
    
    // Animate the scroll to top
      $('.btn-go-top').click(function(event) {
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 700);
      })
      
      
       
                  $('.reasons-card').hover(
                         function(){ 
                           $(this).addClass('hover')
                         },
                         function(){ $(this).removeClass('hover') }
                  )
                  
              
                    
});